interface FormFieldLabelProps {
	editMode: boolean
	labelName: string
}

export const FormFieldLabel = ({
	editMode,
	labelName,
}: FormFieldLabelProps) => {
	return (
		<label
			className={`pb-2 ${!editMode && 'text-gray-500/60'}`}
			htmlFor={labelName}
		>
			{labelName}
		</label>
	)
}
